import Error from './error.js';

export default Error;